import { createApi } from "@reduxjs/toolkit/query/react";
import { getAxiosInstance } from "../../../api";

const axiosBaseQuery =
  () =>
  async ({ params, endpoint, method, body }) => {
    const api = await getAxiosInstance();
    const getParams = (key) => {
      const value = params?.[key];
      // Special handling for array format (like date)
      if (Array.isArray(value)) {
        return value.map((v) => `${key}[]=${v}`).join("&") + "&";
      }
      if (value !== undefined && value !== null && value !== "") {
        return `${key}=${value}&`;
      }
      return "";
    };

    if (method === "get") {
      try {
        const response = await api[method](
          `${endpoint}?${getParams("receipt_id")}${getParams("end")}filter=${
            params?.filter || "all"
          }&${getParams("sort_by")}sort_order=${
            params?.sort_order || "dec"
          }&per_page=${params?.page_size || "10"}&department_id=${
            params?.department_id || ""
          }&activity_type=${
            params?.activity_type || ""
          }&branch_id=${
            params?.branch_id || ""
          }&page=${params?.page || 1}&${getParams(
            "search"
          )}&${getParams("date")}
            `,
          body
        );
        return { data: response.data };
      } catch (axiosError) {
        let err = axiosError;
        return {
          error: {
            status: err.response?.status,
            data: err.response?.data || err.message,
          },
        };
      }
    } else {
      try {
        const response = await api[method](
          `${endpoint}${getParams("start")}${getParams("end")}${getParams(
            "sort_by"
          )}${getParams("search")}`,
          body
        );
        return { data: response.data };
      } catch (axiosError) {
        let err = axiosError;
        return {
          error: {
            status: err.response?.status,
            data: err.response?.data || err.message,
          },
        };
      }
    }
  };

export const certificateUpdateApi = createApi({
  reducerPath: "certificateUpdateApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["certificateUpdate"],
  endpoints: (builder) => ({
    getCertificateUpdateData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/internal-reports/certificate-update`,
      }),
      providesTags: ["certificateUpdate"],
    }),

    updateCertificateUpdateTableHeadData: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/user-fields/save`,
      }),
      invalidatesTags: ["certificateUpdate"],
    }),

    updateCertificatePrice: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/certificate-price-update`,
      }),
      invalidatesTags: ["certificateUpdate"],
    }),
  }),
});

export const {
  useGetCertificateUpdateDataQuery,
  useUpdateCertificateUpdateTableHeadDataMutation,
  useUpdateCertificatePriceMutation,
} = certificateUpdateApi;
